import { combineReducers } from 'redux';
import authReducer from './authReducer';
import currencyReducer from './currencyReducer';
import dateReducer from './dateReducer';

export default combineReducers({
  auth: authReducer,
  date: dateReducer,
  currency: currencyReducer,
});